import React from 'react';
import { AppBar, Toolbar, Typography, Box } from '@mui/material';

const TopBar = ({ title }) => {
    return (
        <AppBar position="static" sx={{ backgroundColor: '#f4f4f4', color: '#333' }}>
            <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" align="center">
                        {title}
                    </Typography>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
